import { Component, ChangeDetectorRef, ChangeDetectionStrategy, ViewRef, Output, EventEmitter, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Column } from '../../models/column';
import { MathFunction } from '../../models/mathfunction';
import { ValueField } from '../../models/valuefield';
import { MDGFormulaSelectorComponent } from '../formula/mdg.formulaselector';
import { HelperService } from '../../Services/Helper.Service';

@Component({
  selector: 'mdg-formula',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // templateUrl: 'MDG.Formula.html',
  template: `<div *ngIf="showFormula" class='mdg-options-container'>
  <div class="mdg-options-popup-container formula-popup">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h3>Configure your own Formula Field</h3>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-5 col-sm-6 col-xs-12 content">
        <div class='border-top-ddd border-left-ddd border-right-ddd'>
          <div class="padding-5 bg-f7f7f7">List of Field(s)
          </div>
        </div>
        <div class="mdg-options-stack-container overflow-y border-ddd">
          <ng-container *ngIf="data.valueField">
            <div class="border-bottom-ddd padding-5 formulae" [class.mdg-selected]='col.column.selected' dnd-draggable [dragData]="col"
              *ngFor="let col of formulaColumns" title="{{col.mathFn.Name + ' of ' + col.column.displayName}}">
              <div class='fcontent'>{{col.mathFn.Name + " of " + col.column.displayName}}</div>
              <!-- <div class="pull-right">{{col.colOrder}}</div> -->
              <div class="option" (click)='showFormulaSelection(col)'>
                <span>fx</span>
                <i class='fa fa-angle-down cursor-pointer'></i>
                <!-- <div class="dropdown-content">
                <a *ngFor="let item of col.mathFns" (click)='selectFn(col,item,$event)'>{{item.Name}}</a>
              </div> -->
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!data.valueField">
            <div class="border-bottom-ddd padding-5" dnd-draggable *ngFor="let col of columns" [dragData]="col" title="{{col.displayName}}">
              <i class='fa fa-reorder cursor-move font-10'></i> {{col.displayName}}
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-md-7 col-sm-6 col-xs-12 content">
        <div class="row">
          <div class="col-md-4 col-sm-5 col-xs-12">
            <label class="padding-5">Formula Name</label>
          </div>
          <div class="col-md-8 col-sm-7 col-xs-12">
            <input class="form-control no-radius" placeholder="Field Name" [(ngModel)]='data.displayName'>
          </div>
        </div>
        <div class="row padding-top-10 padding-bottom-10">
          <div class="col-md-4 col-sm-5 col-xs-12">
            <label class="padding-5">Value Field</label>
          </div>
          <div class="col-md-8 col-sm-7 col-xs-12">
            <label>
              <input type="radio" name='valueField' [value]="true" [(ngModel)]='data.valueField'> Yes</label>
            <label>
              <input type="radio" name='valueField' [value]="false" [(ngModel)]='data.valueField'> No</label>
          </div>
          <div class="col-xs-12 top-buffer--10">
            <small class="padding-left-10">This means, field can be only added as value field. It cannot be used in rows or columns.</small>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 padding-top-5">
            <button class="btn btn-sm btn-default no-radius" *ngFor="let f of formulaArr" (click)='onFCLick(f)'>{{f}}</button>
          </div>
          <div class="col-xs-12">
            <textarea #feditor dnd-droppable placeholder="Formula field editor" [(ngModel)]='data.formula' (onDropSuccess)="onDropped($event)"
              class="form-control no-radius formula-editor"></textarea>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='saveField()'>Save</button>
            <button class='btn btn-sm btn-default' (click)='showFormula = false'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<mdg-formulaselector #formulaselector (updateFormula)='onFSUpdateFormula($event)'></mdg-formulaselector>
`
})
export class MDGFormulaComponent {

  @Input() columns: Column[] = [];
  @Input() formulas: MathFunction[] = [];
  @Output() updateFormula: EventEmitter<Column> = new EventEmitter<Column>();
  @Output() errorFormula: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('feditor') feditor: ElementRef;
  @ViewChild('formulaselector') formulaselector: MDGFormulaSelectorComponent;

  formulaColumns: ValueField[] = [];
  showFormula: boolean = false;
  formulaArr: string[] = [];
  data: Column;
  selectedValue: ValueField;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showFormula && !this.formulaselector.showFormula) {
      this.showFormula = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private helper: HelperService) {
    this.formulaArr.push('+');
    this.formulaArr.push('-');
    this.formulaArr.push('*');
    this.formulaArr.push('/');
    this.formulaArr.push('=');
    this.formulaArr.push('?');
    this.formulaArr.push('<');
    this.formulaArr.push('>');
    this.formulaArr.push('<=');
    this.formulaArr.push('>=');
    this.formulaArr.push('!=');
    this.formulaArr.push('==');
  }

  updateFormulaFields() {
    this.formulaColumns = [];
    this.columns.forEach(f => {
      const obj = new ValueField();
      obj.column = f;
      if (f.dataType === 'number') {
        obj.mathFn = this.formulas.filter(fm => fm.funcName === 'sum')[0];
        obj.mathFns = this.formulas;
      } else if (f.dataType === 'date') {
        obj.mathFn = this.formulas.filter(fm => fm.funcName === 'count')[0];
        obj.mathFns = this.formulas.filter(fm => fm.funcName === 'count' || fm.funcName === 'dcount' || fm.funcName === 'min' || fm.funcName === 'max');
      } else {
        obj.mathFn = this.formulas.filter(fm => fm.funcName === 'count')[0];
        obj.mathFns = this.formulas.filter(fm => fm.funcName === 'count' || fm.funcName === 'dcount');
      }
      this.formulaColumns.push(obj);
    });
  }

  showFormulaSelection(formula: ValueField) {
    this.selectedValue = formula;
    this.formulaselector.ShowFormula(formula);
  }

  onFSUpdateFormula(fn: MathFunction) {
    this.selectedValue.mathFn = fn;
  }

  AddFormula() {
    this.data = new Column();
    this.data.header = this.helper.getHeaderStyle();
    this.data.cell = this.helper.getCellStyle();
    this.data.colName = '';
    this.data.displayName = '';
    this.data.formula = '';
    this.data.dataType = 'number';
    this.data.valueField = false;
    this.showFormula = true;
    this.updateFormulaFields();
    this.detectChanges();
  }

  EditFormula(data: Column) {
    this.data = data;
    this.showFormula = true;
    this.updateFormulaFields();
    this.detectChanges();
  }

  onFCLick(f: any) {
    const fValue = this.feditor.nativeElement.value;
    const caretStart = this.feditor.nativeElement.selectionStart;
    const caretEnd = this.feditor.nativeElement.selectionEnd;
    const str1 = fValue.substring(0, caretStart);
    const str2 = fValue.substring(caretEnd, fValue.length);
    this.data.formula = str1 + f + str2;
    this.feditor.nativeElement.focus();
  }

  onDropped(col: any) {
    if (col.dragData !== undefined && col.dragData instanceof Column) {
      const fValue = this.feditor.nativeElement.value;
      const caretStart = this.feditor.nativeElement.selectionStart;
      const caretEnd = this.feditor.nativeElement.selectionEnd;
      const str1 = fValue.substring(0, caretStart);
      const str2 = fValue.substring(caretEnd, fValue.length);
      this.data.formula = str1 + ' ' + col.dragData.colName + ' ' + str2;
      this.feditor.nativeElement.focus();
    }
    if (col.dragData !== undefined && col.dragData instanceof ValueField) {
      const fValue = this.feditor.nativeElement.value;
      const caretStart = this.feditor.nativeElement.selectionStart;
      const caretEnd = this.feditor.nativeElement.selectionEnd;
      const str1 = fValue.substring(0, caretStart);
      const str2 = fValue.substring(caretEnd, fValue.length);
      this.data.formula = str1 + ' ' + col.dragData.mathFn.funcName + '(' + col.dragData.column.colName + ') ' + str2;
      this.feditor.nativeElement.focus();
    }
  }

  saveField() {
    if (this.data.displayName === undefined || this.data.displayName === null || this.data.displayName.trim() === '') {
      this.errorFormula.emit('Please provide formula name.');
    } else if (this.data.formula === undefined || this.data.formula === null || this.data.formula.trim() === '') {
      this.errorFormula.emit('Please provide formula.');
    } else {
      this.findFields();
      this.data.colName = this.data.displayName;
      this.showFormula = false;
      setTimeout(() => {
        this.updateFormula.emit(this.data);
      }, 10);
    }
  }

  findFields() {
    this.data.fields = [];
    if (this.data.valueField) {
      let formulaStr = this.data.formula;
      this.formulas.forEach(f => {
        while (formulaStr.includes(f.funcName.toString())) {
          let formulaField = formulaStr.substring(formulaStr.indexOf(f.funcName.toString()));
          formulaField = formulaField.substring(0, formulaField.indexOf(')'));
          const colName = formulaField.replace(f.funcName + '(', '');
          formulaStr = formulaStr.replace(formulaField + ')', '');
          if (this.data.fields.filter(fl => fl.colName === colName && fl.aggregation === f.funcName).length <= 0) {
            const col = this.columns.filter(fCol => fCol.colName === colName);
            this.data.fields.push({ colName: colName, dataType: col[0].dataType, aggregation: f.funcName });
          }
        }
      });
    } else {
      this.columns.forEach(fl => {
        if (this.data.formula.includes(fl.colName.toString())) {
          this.data.fields.push({ colName: fl.colName.toString(), dataType: fl.dataType });
        }
      });
    }
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
